export default __webpack_public_path__ + "ec94937b4a333e9ce2ffdccf034e7198.pdf";